import { Box, Button, IconButton, Typography } from '@mui/material'
import MuiDialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import infoIcon from '@/assets/images/tooltipIcon.svg'

interface DialogProps {
  title: string
}

const PlanDialog: React.FC<DialogProps> = ({ title }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'comparePlans' })
  const [open, setOpen] = React.useState(false)
  return (
    <React.Fragment>
      <IconButton
        style={{ padding: 0, transform: 'scale(1.3)' }}
        aria-label="info"
        onClick={() => setOpen(true)}
      >
        <img src={infoIcon} alt="" height="12px" width="12px" />
      </IconButton>
      <MuiDialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          '& .MuiPaper-root': {
            bgcolor: '#2E2E2E !important',
            color: 'white',
          },
        }}
      >
        <DialogTitle sx={{ py: 2, px: 3 }} id="alert-dialog-title">
          <Typography sx={{ fontSize: '20px', fontWeight: 500 }}>
            {t(title)}{' '}
            {['enamelStudio', 'dehazing', 'colorChecker'].includes(title) &&
              t('digitalTryIn')}
            {title === 'frameworkStaining' && t('washBake')}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ py: 2, px: 3 }}>
          {' '}
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              fontFamily: 'Roboto, sans-serif',
              color: 'white',
            }}
          >
            {t(`${title}Tooltip`)}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ py: 2, px: 3 }}>
          <Box display="flex" justifyContent="end" gap={2}>
            <Button
              sx={{ color: '#90CAF9', fontSize: '12px' }}
              onClick={() => setOpen(false)}
            >
              Done
            </Button>
          </Box>
        </DialogActions>
      </MuiDialog>
    </React.Fragment>
  )
}
export default PlanDialog
